import { ui } from 'modules/common';
import { TimeReference } from 'modules/common/ui';
import moment from 'moment/moment';
import { useCallback, useMemo } from 'react';

import { useReportSchedulerContext } from '../../ReportSchedulerPopup.context';

export const useDateOptionSelect = (ruleIndex: number) => {
    const { schedule, updateRuleConfig } = useReportSchedulerContext();

    const ruleConfig = schedule.rules[ruleIndex].configuration;
    const dayOfYear = ruleConfig.dayOfYear;

    const daysAmount = useMemo(() => {
        const monthIndex =
            ui.allMonthReferences.find((month) => month.monthIndex === dayOfYear?.month)?.monthIndex || 1;

        const isFebruary = monthIndex === 2;
        const monthDays = moment()
            .set('month', monthIndex - 1)
            .daysInMonth();

        return isFebruary ? 28 : monthDays;
    }, [dayOfYear?.month]);

    const handleChange = useCallback(
        (value: number) => {
            updateRuleConfig(ruleIndex, {
                dayOfYear: {
                    month: value || 1,
                    day: dayOfYear?.day || 1,
                },
            });
        },
        [dayOfYear?.day, ruleIndex, updateRuleConfig]
    );

    return {
        value: ruleConfig.dayOfYear?.month || 1,
        daysAmount,
        handleChange,
    };
};

export const useDayOptionSelect = (ruleIndex: number) => {
    const { schedule, updateRuleConfig } = useReportSchedulerContext();

    const ruleConfig = schedule.rules[ruleIndex].configuration;
    const dayOfYear = ruleConfig.dayOfYear;

    const handleChange = useCallback(
        (value: number) => {
            updateRuleConfig(ruleIndex, {
                dayOfYear: {
                    month: dayOfYear?.month || 1,
                    day: value || 1,
                },
            });
        },
        [dayOfYear?.month, ruleIndex, updateRuleConfig]
    );

    return {
        value: dayOfYear?.day || 1,
        handleChange,
    };
};

export const useTimeOptionSelect = (ruleIndex: number) => {
    const { schedule, updateRuleConfig } = useReportSchedulerContext();

    const ruleConfig = schedule.rules[ruleIndex].configuration;

    const handleChange = useCallback(
        (value: string, options: TimeReference[]) => {
            const option = options.find((timeRef) => timeRef.text === value);

            if (option) {
                updateRuleConfig(ruleIndex, {
                    time: {
                        hour: option.hours,
                        minute: option.minutes,
                    },
                });
            }
        },
        [ruleIndex, updateRuleConfig]
    );

    return {
        value: ruleConfig.time,
        handleChange,
    };
};
